export const formatNumberToKZT = (num: number) =>
  new Intl.NumberFormat("ru-KZ", {
    style: "currency",
    currency: "KZT",
    currencyDisplay: "symbol"
  }).format(num);
